import { autoinject } from 'aurelia-dependency-injection';
import { Router } from 'aurelia-router';
import { MyVesselsRouteConstants } from '../../../constants/route.constants';

@autoinject
export class NotFound {

    constructor(private router: Router) { }

    navigateBackHome() {
        this.router.navigate(MyVesselsRouteConstants.Dashboard);
    }
}